import { render } from "./ActiveUserPage.vue?vue&type=template&id=57863b19&ts=true"
import script from "./ActiveUserPage.vue?vue&type=script&lang=ts"
export * from "./ActiveUserPage.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__